<div (click)="filtrar(competencia.nombre)" [ngClass]="setColor(competencia)" [style.background-color]="competencia.color">
    <span id="number">{{ competencia.cantidad }}</span>
    <!-- <img [src]="competencia.img" style="filter: invert(1);" class="img-fluid" width="100%" height="100%"> -->
    <img [src]="filespath + competencia.img" class="img-fluid" width="100%" height="50%">
    <span  [style.background-color]="competencia.color">{{ competencia.nombre }}</span>
</div>


